// packages/shared/src/services/timeTracking/timesheetCsv.ts
import type { TimesheetGrid } from './timesheetAggregate';

const SEP = ';';

function esc(v: string): string {
  if (v.includes(SEP) || v.includes('"') || v.includes('\n') || v.includes('\r')) {
    return `"${v.replace(/"/g, '""')}"`;
  }
  return v;
}

/** dossierLabels maps dossier_id → human label (reference). Missing → the id. */
export function timesheetToCsv(grid: TimesheetGrid, dossierLabels: Record<string, string>): string {
  const cols = grid.dossierIds;
  const header = ['Jour', ...cols.map((id) => esc(dossierLabels[id] ?? id)), 'Total jour'];
  const lines = [header.join(SEP)];

  for (const row of grid.rows) {
    const cells = cols.map((id) => String(row.cells[id]?.total ?? 0));
    lines.push([esc(row.day), ...cells, String(row.dayTotal)].join(SEP));
  }

  const totalsRow = [
    'Total dossier',
    ...cols.map((id) => String(grid.dossierTotals[id] ?? 0)),
    String(grid.grandTotal),
  ];
  lines.push(totalsRow.join(SEP));

  return lines.join('\n') + '\n';
}
